<template>
  <div class="container page" style="background: #1f1c1f;">
    <van-nav-bar :title="$t('setting.bind_account')" class="nav-bar">
      <template #left>
        <img src="/img/newLogin/download.png" @click="back()" style="width: 20px;height: 15px;"/>
      </template>
    </van-nav-bar>
    <div class="type-switch">
      <div
        class="type-item"
        :class="{ active: bindType === 'bank' }"
        @click="bindType = 'bank'"
      >
        {{ $t('setting.bank_card') }}
      </div>
      <div
        class="type-item"
        :class="{ active: bindType === 'crypto' }"
        @click="bindType = 'crypto'"
      >
        {{ $t('setting.crypto_wallet') }}
      </div>
    </div>
    <div class="main-box">
      <div class="label">{{$t("setting.bind_account_tip")}}</div>
      <van-cell-group>
        <template v-if="bindType === 'bank'">
          <van-field v-model="username" :label="$t('setting.username')" :placeholder="$t('setting.username_place')" />
          <van-field v-model="bank" :label="$t('setting.band_name')" :placeholder="$t('setting.band_name_tip')" />
          <van-field v-model="bankid" :label="$t('setting.band_account')" :placeholder="$t('setting.band_account_tip')" />
        </template>
        <template v-else>
          <div class="chain-switch">
            <div
              class="chain-item"
              :class="{ active: chainType === 'TRC20' }"
              @click="changeChainType('TRC20')"
            >
              TRC20
            </div>
            <div
              class="chain-item"
              :class="{ active: chainType === 'ERC20' }"
              @click="changeChainType('ERC20')"
            >
              ERC20
            </div>
          </div>
          <van-field v-model="walletAddress" @input="handleWalletAddressInput" :label="$t('setting.wallet_address')" :placeholder="$t('setting.wallet_address_tip')" />
        </template>
      </van-cell-group>
    </div>
    <div class="sub-btn" @click="bindCard()">
      {{$t("setting.bank_ok")}}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: {},
      bindType: 'bank',
      bankid: "",
      username: "",
      bank: "",
      chainType: 'TRC20',
      walletAddress: "",
      trc20Address: "",
      erc20Address: ""
    };
  },
  methods: {
    back() {
      if (window.history.length > 1) {
        return window.history.back();
      }
      this.$router.replace({ path: '/Setbank' });
    },
    changeChainType(type) {
      this.chainType = type;
      this.syncWalletAddress();
    },
    syncWalletAddress() {
      this.walletAddress = this.chainType === 'ERC20' ? this.erc20Address : this.trc20Address;
    },
    handleWalletAddressInput(value) {
      if (this.chainType === 'ERC20') {
        this.erc20Address = value;
      } else {
        this.trc20Address = value;
      }
    },
    bindCard() {
      if (this.bindType === 'bank') {
        if (!this.bank) {
          this.$toast.fail(this.$t("setting.band_name_tip"));
          return false;
        }
        if (!this.username) {
          this.$toast(this.$t("setting.username_place"));
          return false;
        }
        if (!this.bankid) {
          this.$toast(this.$t("setting.band_account_tip"));
          return false;
        }
      } else {
        if (!this.chainType) {
          this.$toast(this.$t("setting.chain_type_tip"));
          return false;
        }
        if (!this.walletAddress) {
          this.$toast(this.$t("setting.wallet_address_tip"));
          return false;
        }
      }

      this.$http({
        method: 'post',
        data: {
          pay_type: this.bindType,
          bankid: this.bankid,
          bank: this.bank,
          username: this.username,
          chain_type: this.chainType,
          wallet_address: this.walletAddress
        },
        url: 'user_set_bank'
      }).then(res => {
        if (res.code === 200) {
          this.$router.replace({ path: '/Mine' });
          this.$toast(res.msg);
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getUserBankInfo() {
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if (res.code === 200) {
          if (res.data.is_bank) {
            const info = res.data.info || {};
            this.bindType = info.pay_type === 'crypto' ? 'crypto' : 'bank';
            this.bank = info.bankinfo || "";
            this.bankid = info.bankid || "";
            this.username = info.username || "";
            this.trc20Address = info.trc20_address || "";
            this.erc20Address = info.erc20_address || "";
            this.chainType = info.chain_type || 'TRC20';
            this.syncWalletAddress();
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({path:'/Login'});
    } else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.sub-btn{
  background: linear-gradient(#fde3ca, #e7b486);


  display: inline-block;
  border: none;
  cursor: pointer;
  color: #68302c;
  font-size: 32px;
  -moz-border-radius: 5px;
  -webkit-border-radius: 5px;
  border-radius: 2rem;
  margin: 60px 40px;
  font-weight: bold;
  text-align: center;
  padding: 20px 0;
}
.type-switch{
  display: flex;
  margin: 30px 30px 0;
  border: 1px solid #766350;
  border-radius: 12px;
  overflow: hidden;
  .type-item{
    flex: 1;
    text-align: center;
    color: #f3c7a2;
    font-size: 28px;
    padding: 22px 0;
    background: #2a2a2a;
    &.active{
      background: linear-gradient(#fde3ca, #e7b486);
      color: #68302c;
      font-weight: bold;
    }
  }
}
.chain-switch{
  display: flex;
  margin: 0 30px 20px;
  .chain-item{
    flex: 1;
    text-align: center;
    color: #f3c7a2;
    font-size: 26px;
    padding: 20px 0;
    border: 1px solid #766350;
    background: linear-gradient(120deg, #212121, #313131);
    &:first-child{
      margin-right: 20px;
    }
    &.active{
      background: linear-gradient(#fde3ca, #e7b486);
      color: #68302c;
      font-weight: bold;
    }
  }
}
/deep/ .van-field__label{
  color: #ccc;
}
.van-cell-group{
  background-color: transparent;
  padding: 30px 0;
  &:after{
    display: none;
  }
}
.van-cell{
  background: linear-gradient(120deg, #212121, #313131);
  margin: 0 30px;
  box-sizing: border-box;
  width: initial;
  border: 1px solid #766350;
  border-radius: 10px;
  font-size: 28px;
  padding: 20px 26px;
  margin-bottom: 20px;
  /deep/ .van-field__control{
    color: #f3c7a2;
  }
  &:after{
    display: none;
  }
}

.bankbox{
  padding: 15px;
  color: #000;
  background-color: #fff;
}
.bankbox .title{
  padding: 8px 10px 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 28px;
}

.main-box .label{
  padding: 20px 0 20px 26px;
  font-size: 35px;
  color: #f3c7a2;
}
::v-deep .van-picker__toolbar {
  height: 50px;
}
::v-deep .van-picker__cancel, .van-picker__confirm {
  padding: 0 20px;
  font-size: 20px;
}
::v-deep .van-picker-column {
  font-size: 40px;
}
.main-box p{
  padding: 0 20px;
  font-size: 30px;
  color: #f3c7a2;
}
.bindCard {
  margin: 20px 30px 0;
  height: 80px;
  line-height: 1.22667rem;
  border-radius: 50px;
  color: #fff;
  font-size: 30px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(
      90deg,#e6c3a1,#7e5678);
}
</style>
